import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from '@app/shared';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppPurchaseOrderService } from '@services/purchase-order.service';
import { MentionModule } from 'angular-mentions';
import { DxDataGridModule, DxTreeListModule } from 'devextreme-angular';
import { DragulaModule } from 'ng2-dragula';
import { NgxLoadingModule } from 'ngx-loading';
import { StickyDirectiveModule } from 'ngx-sticky-directive';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { WorkflowsComponent } from './workflows.component';
import { WorkflowsRoutingModule } from './workflows-routing.module';
import { WorkflowDetailComponent } from './containers/workflow-detail/workflow-detail.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { AttachmentsComponent } from './components/attachments/attachments.component';
import { WorkflowCreationModalComponent } from './modals/workflow-creation-modal/workflow-creation-modal.component';
import { TaskCreationModalComponent } from './modals/task-creation-modal/task-creation-modal.component';
import { TaskInstanceModalComponent } from './modals/task-instance-modal/task-instance-modal.component';
import { ApplyWorkflowModalComponent } from './modals/apply-workflow-modal/apply-workflow-modal.component';
import { LinkyModule } from 'ngx-linky';
import { MarkdownModule } from 'ngx-markdown';
import { LMarkdownEditorModule } from 'ngx-markdown-editor';

const MODALS = [
  WorkflowCreationModalComponent,
  TaskCreationModalComponent,
  TaskInstanceModalComponent,
  ApplyWorkflowModalComponent,
];

@NgModule({
  imports: [
    CommonModule,
    DragulaModule,
    DxDataGridModule,
    DxTreeListModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MentionModule,
    NgOptionHighlightModule,
    NgSelectModule,
    NgxLoadingModule,
    SharedModule,
    StickyDirectiveModule,
    WorkflowsRoutingModule,
    LinkyModule,
    MarkdownModule.forChild(),
    LMarkdownEditorModule,
  ],
  declarations: [
    WorkflowDetailComponent,
    TimelineComponent,
    AttachmentsComponent,
    WorkflowsComponent,
    ...MODALS,
  ],
  exports: [
    MatFormFieldModule,
    MatInputModule,
    WorkflowsRoutingModule,
    WorkflowDetailComponent,
    TimelineComponent,
    AttachmentsComponent,
    WorkflowsComponent,
    ...MODALS,
  ],
  providers: [
    AppPurchaseOrderService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
  ],
  entryComponents: [
    WorkflowDetailComponent,
    TimelineComponent,
    AttachmentsComponent,
    WorkflowsComponent,
    ...MODALS,
  ],
})

export class WorkflowsModule {
}
